/* eslint-disable */ // @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './routes/__root';
import { Route as ProfileRouteImport } from './routes/profile';
import { Route as LogoutRouteImport } from './routes/logout';
import { Route as LoginRouteImport } from './routes/login';
import { Route as R403RouteImport } from './routes/403';
import { Route as OrgRouteRouteImport } from './routes/org/route';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ProfileIndexRouteImport } from './routes/profile/index';
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email';
import { Route as AuthCallbackRouteImport } from './routes/auth/callback';
import { Route as OrgOrganizationRouteRouteImport } from './routes/org/$organization/route';
import { Route as ProfileSettingsIndexRouteImport } from './routes/profile/settings/index';
import { Route as ProfileUsernameIndexRouteImport } from './routes/profile/$username/index';
import { Route as OrgOrganizationIndexRouteImport } from './routes/org/$organization/index';
import { Route as ProfileSettingsEmailSettingsRouteImport } from './routes/profile/settings/email-settings';
import { Route as OrgOrganizationManagedApplicationsRouteImport } from './routes/org/$organization/managed-applications';
import { Route as OrgOrganizationSettingsRouteRouteImport } from './routes/org/$organization/settings/route';
import { Route as OrgOrganizationProjectsRouteRouteImport } from './routes/org/$organization/projects/route';
import { Route as OrgOrganizationProjectRouteRouteImport } from './routes/org/$organization/$project/route';
import { Route as ProfileSettingsUserTokensIndexRouteImport } from './routes/profile/settings/user-tokens/index';
import { Route as OrgOrganizationSettingsIndexRouteImport } from './routes/org/$organization/settings/index';
import { Route as OrgOrganizationProjectIndexRouteImport } from './routes/org/$organization/$project/index';
import { Route as ProfileSettingsUserTokensGenerateRouteImport } from './routes/profile/settings/user-tokens/generate';
import { Route as ProfileSettingsUserTokensUsertokenRouteImport } from './routes/profile/settings/user-tokens/$usertoken';
import { Route as OrgOrganizationSettingsPeopleRouteImport } from './routes/org/$organization/settings/people';
import { Route as OrgOrganizationSettingsMembershipRouteImport } from './routes/org/$organization/settings/membership';
import { Route as OrgOrganizationSettingsAuditLogRouteImport } from './routes/org/$organization/settings/audit-log';
import { Route as OrgOrganizationSettingsTeamsRouteRouteImport } from './routes/org/$organization/settings/teams/route';
import { Route as OrgOrganizationSettingsSubscriptionRouteRouteImport } from './routes/org/$organization/settings/subscription/route';
import { Route as OrgOrganizationSettingsServerTokensRouteRouteImport } from './routes/org/$organization/settings/server-tokens/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsRouteRouteImport } from './routes/org/$organization/settings/deployment-integrations/route';
import { Route as OrgOrganizationProjectSettingsRouteRouteImport } from './routes/org/$organization/$project/settings/route';
import { Route as OrgOrganizationProjectApplicationsRouteRouteImport } from './routes/org/$organization/$project/applications/route';
import { Route as OrgOrganizationSettingsTeamsIndexRouteImport } from './routes/org/$organization/settings/teams/index';
import { Route as OrgOrganizationSettingsSubscriptionIndexRouteImport } from './routes/org/$organization/settings/subscription/index';
import { Route as OrgOrganizationSettingsServerTokensIndexRouteImport } from './routes/org/$organization/settings/server-tokens/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/index';
import { Route as OrgOrganizationProjectApplicationsIndexRouteImport } from './routes/org/$organization/$project/applications/index';
import { Route as OrgOrganizationSettingsTeamsTeamRouteImport } from './routes/org/$organization/settings/teams/$team';
import { Route as OrgOrganizationSettingsSubscriptionManageRouteImport } from './routes/org/$organization/settings/subscription/manage';
import { Route as OrgOrganizationSettingsServerTokensNewRouteImport } from './routes/org/$organization/settings/server-tokens/new';
import { Route as OrgOrganizationSettingsServerTokensTokenRouteImport } from './routes/org/$organization/settings/server-tokens/$token';
import { Route as OrgOrganizationProjectSettingsGeneralRouteImport } from './routes/org/$organization/$project/settings/general';
import { Route as OrgOrganizationProjectSettingsCollaborationsTeamsRouteImport } from './routes/org/$organization/$project/settings/collaborations-teams';
import { Route as OrgOrganizationProjectDevopsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/devops/deployment-integrations';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/route';
import { Route as OrgOrganizationProjectAppApplicationRouteRouteImport } from './routes/org/$organization/$project/app/$application/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/index';
import { Route as OrgOrganizationProjectAppApplicationIndexRouteImport } from './routes/org/$organization/$project/app/$application/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/add';
import { Route as OrgOrganizationProjectAppApplicationVersionsRouteRouteImport } from './routes/org/$organization/$project/app/$application/versions/route';
import { Route as OrgOrganizationProjectAppApplicationSettingsRouteRouteImport } from './routes/org/$organization/$project/app/$application/settings/route';
import { Route as OrgOrganizationProjectAppApplicationDevopsRouteRouteImport } from './routes/org/$organization/$project/app/$application/devops/route';
import { Route as OrgOrganizationProjectAppApplicationActivityRouteRouteImport } from './routes/org/$organization/$project/app/$application/activity/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/index';
import { Route as OrgOrganizationProjectAppApplicationVersionsIndexRouteImport } from './routes/org/$organization/$project/app/$application/versions/index';
import { Route as OrgOrganizationProjectAppApplicationUmlIndexRouteImport } from './routes/org/$organization/$project/app/$application/uml/index';
import { Route as OrgOrganizationProjectAppApplicationSettingsIndexRouteImport } from './routes/org/$organization/$project/app/$application/settings/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/edit';
import { Route as OrgOrganizationProjectAppApplicationVersionsVersionidRouteImport } from './routes/org/$organization/$project/app/$application/versions/$versionid';
import { Route as OrgOrganizationProjectAppApplicationSettingsGeneralRouteImport } from './routes/org/$organization/$project/app/$application/settings/general';
import { Route as OrgOrganizationProjectAppApplicationSettingsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/app/$application/settings/deployment-integrations';
import { Route as OrgOrganizationProjectAppApplicationDevopsRedeploymentRouteImport } from './routes/org/$organization/$project/app/$application/devops/redeployment';
import { Route as OrgOrganizationProjectAppApplicationDevopsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/app/$application/devops/deployment-integrations';
import { Route as OrgOrganizationProjectAppApplicationActivityContributorsRouteImport } from './routes/org/$organization/$project/app/$application/activity/contributors';
import { Route as OrgOrganizationProjectAppApplicationActivityAuditLogRouteImport } from './routes/org/$organization/$project/app/$application/activity/audit-log';
import { Route as OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteImport } from './routes/org/$organization/$project/app/$application/devops/tags/route';
import { Route as OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteImport } from './routes/org/$organization/$project/app/$application/devops/release-pipeline-board/route';
import { Route as OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteImport } from './routes/org/$organization/$project/app/$application/devops/release-pipeline/route';
import { Route as OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteImport } from './routes/org/$organization/$project/app/$application/devops/environment/route';
import { Route as OrgOrganizationProjectAppApplicationDevopsTagsIndexRouteImport } from './routes/org/$organization/$project/app/$application/devops/tags/index';
import { Route as OrgOrganizationProjectAppApplicationDevopsReleasePipelineIndexRouteImport } from './routes/org/$organization/$project/app/$application/devops/release-pipeline/index';
import { Route as OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardIndexRouteImport } from './routes/org/$organization/$project/app/$application/devops/release-pipeline-board/index';
import { Route as OrgOrganizationProjectAppApplicationDevopsEnvironmentIndexRouteImport } from './routes/org/$organization/$project/app/$application/devops/environment/index';
import { Route as OrgOrganizationProjectAppApplicationDevopsTagsAddRouteImport } from './routes/org/$organization/$project/app/$application/devops/tags/add';
import { Route as OrgOrganizationProjectAppApplicationDevopsTagsTagRouteImport } from './routes/org/$organization/$project/app/$application/devops/tags/$tag';
import { Route as OrgOrganizationProjectAppApplicationDevopsEnvironmentAddRouteImport } from './routes/org/$organization/$project/app/$application/devops/environment/add';
import { Route as OrgOrganizationProjectAppApplicationDevopsEnvironmentEnvironmentRouteImport } from './routes/org/$organization/$project/app/$application/devops/environment/$environment';
const ProfileRoute = ProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: ()=>rootRouteImport
});
const LogoutRoute = LogoutRouteImport.update({
    id: '/logout',
    path: '/logout',
    getParentRoute: ()=>rootRouteImport
});
const LoginRoute = LoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: ()=>rootRouteImport
});
const R403Route = R403RouteImport.update({
    id: '/403',
    path: '/403',
    getParentRoute: ()=>rootRouteImport
});
const OrgRouteRoute = OrgRouteRouteImport.update({
    id: '/org',
    path: '/org',
    getParentRoute: ()=>rootRouteImport
});
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>rootRouteImport
});
const ProfileIndexRoute = ProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>ProfileRoute
});
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
    id: '/auth/verify-email',
    path: '/auth/verify-email',
    getParentRoute: ()=>rootRouteImport
});
const AuthCallbackRoute = AuthCallbackRouteImport.update({
    id: '/auth/callback',
    path: '/auth/callback',
    getParentRoute: ()=>rootRouteImport
});
const OrgOrganizationRouteRoute = OrgOrganizationRouteRouteImport.update({
    id: '/$organization',
    path: '/$organization',
    getParentRoute: ()=>OrgRouteRoute
});
const ProfileSettingsIndexRoute = ProfileSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: ()=>ProfileRoute
});
const ProfileUsernameIndexRoute = ProfileUsernameIndexRouteImport.update({
    id: '/$username/',
    path: '/$username/',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationIndexRoute = OrgOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const ProfileSettingsEmailSettingsRoute = ProfileSettingsEmailSettingsRouteImport.update({
    id: '/settings/email-settings',
    path: '/settings/email-settings',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationManagedApplicationsRoute = OrgOrganizationManagedApplicationsRouteImport.update({
    id: '/managed-applications',
    path: '/managed-applications',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationSettingsRouteRoute = OrgOrganizationSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationProjectsRouteRoute = OrgOrganizationProjectsRouteRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationProjectRouteRoute = OrgOrganizationProjectRouteRouteImport.update({
    id: '/$project',
    path: '/$project',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const ProfileSettingsUserTokensIndexRoute = ProfileSettingsUserTokensIndexRouteImport.update({
    id: '/settings/user-tokens/',
    path: '/settings/user-tokens/',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationSettingsIndexRoute = OrgOrganizationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationProjectIndexRoute = OrgOrganizationProjectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const ProfileSettingsUserTokensGenerateRoute = ProfileSettingsUserTokensGenerateRouteImport.update({
    id: '/settings/user-tokens/generate',
    path: '/settings/user-tokens/generate',
    getParentRoute: ()=>ProfileRoute
});
const ProfileSettingsUserTokensUsertokenRoute = ProfileSettingsUserTokensUsertokenRouteImport.update({
    id: '/settings/user-tokens/$usertoken',
    path: '/settings/user-tokens/$usertoken',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationSettingsPeopleRoute = OrgOrganizationSettingsPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsMembershipRoute = OrgOrganizationSettingsMembershipRouteImport.update({
    id: '/membership',
    path: '/membership',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsAuditLogRoute = OrgOrganizationSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsTeamsRouteRoute = OrgOrganizationSettingsTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsSubscriptionRouteRoute = OrgOrganizationSettingsSubscriptionRouteRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsServerTokensRouteRoute = OrgOrganizationSettingsServerTokensRouteRouteImport.update({
    id: '/server-tokens',
    path: '/server-tokens',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsRouteRoute = OrgOrganizationSettingsDeploymentIntegrationsRouteRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationProjectSettingsRouteRoute = OrgOrganizationProjectSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationProjectApplicationsRouteRoute = OrgOrganizationProjectApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationSettingsTeamsIndexRoute = OrgOrganizationSettingsTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsTeamsRouteRoute
});
const OrgOrganizationSettingsSubscriptionIndexRoute = OrgOrganizationSettingsSubscriptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsSubscriptionRouteRoute
});
const OrgOrganizationSettingsServerTokensIndexRoute = OrgOrganizationSettingsServerTokensIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsRouteRoute
});
const OrgOrganizationProjectApplicationsIndexRoute = OrgOrganizationProjectApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationsRouteRoute
});
const OrgOrganizationSettingsTeamsTeamRoute = OrgOrganizationSettingsTeamsTeamRouteImport.update({
    id: '/$team',
    path: '/$team',
    getParentRoute: ()=>OrgOrganizationSettingsTeamsRouteRoute
});
const OrgOrganizationSettingsSubscriptionManageRoute = OrgOrganizationSettingsSubscriptionManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: ()=>OrgOrganizationSettingsSubscriptionRouteRoute
});
const OrgOrganizationSettingsServerTokensNewRoute = OrgOrganizationSettingsServerTokensNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationSettingsServerTokensTokenRoute = OrgOrganizationSettingsServerTokensTokenRouteImport.update({
    id: '/$token',
    path: '/$token',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationProjectSettingsGeneralRoute = OrgOrganizationProjectSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: ()=>OrgOrganizationProjectSettingsRouteRoute
});
const OrgOrganizationProjectSettingsCollaborationsTeamsRoute = OrgOrganizationProjectSettingsCollaborationsTeamsRouteImport.update({
    id: '/collaborations-teams',
    path: '/collaborations-teams',
    getParentRoute: ()=>OrgOrganizationProjectSettingsRouteRoute
});
const OrgOrganizationProjectDevopsDeploymentIntegrationsRoute = OrgOrganizationProjectDevopsDeploymentIntegrationsRouteImport.update({
    id: '/devops/deployment-integrations',
    path: '/devops/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteImport.update({
    id: '/$integrationType',
    path: '/$integrationType',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsRouteRoute
});
const OrgOrganizationProjectAppApplicationRouteRoute = OrgOrganizationProjectAppApplicationRouteRouteImport.update({
    id: '/app/$application',
    path: '/app/$application',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectAppApplicationIndexRoute = OrgOrganizationProjectAppApplicationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectAppApplicationVersionsRouteRoute = OrgOrganizationProjectAppApplicationVersionsRouteRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationProjectAppApplicationSettingsRouteRoute = OrgOrganizationProjectAppApplicationSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsRouteRoute = OrgOrganizationProjectAppApplicationDevopsRouteRouteImport.update({
    id: '/devops',
    path: '/devops',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationProjectAppApplicationActivityRouteRoute = OrgOrganizationProjectAppApplicationActivityRouteRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRouteImport.update({
    id: '/$integrationName/',
    path: '/$integrationName/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectAppApplicationVersionsIndexRoute = OrgOrganizationProjectAppApplicationVersionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationVersionsRouteRoute
});
const OrgOrganizationProjectAppApplicationUmlIndexRoute = OrgOrganizationProjectAppApplicationUmlIndexRouteImport.update({
    id: '/uml/',
    path: '/uml/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationRouteRoute
});
const OrgOrganizationProjectAppApplicationSettingsIndexRoute = OrgOrganizationProjectAppApplicationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationSettingsRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRouteImport.update({
    id: '/$integrationName/edit',
    path: '/$integrationName/edit',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectAppApplicationVersionsVersionidRoute = OrgOrganizationProjectAppApplicationVersionsVersionidRouteImport.update({
    id: '/$versionid',
    path: '/$versionid',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationVersionsRouteRoute
});
const OrgOrganizationProjectAppApplicationSettingsGeneralRoute = OrgOrganizationProjectAppApplicationSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationSettingsRouteRoute
});
const OrgOrganizationProjectAppApplicationSettingsDeploymentIntegrationsRoute = OrgOrganizationProjectAppApplicationSettingsDeploymentIntegrationsRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationSettingsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsRedeploymentRoute = OrgOrganizationProjectAppApplicationDevopsRedeploymentRouteImport.update({
    id: '/redeployment',
    path: '/redeployment',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsDeploymentIntegrationsRoute = OrgOrganizationProjectAppApplicationDevopsDeploymentIntegrationsRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationActivityContributorsRoute = OrgOrganizationProjectAppApplicationActivityContributorsRouteImport.update({
    id: '/contributors',
    path: '/contributors',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationActivityRouteRoute
});
const OrgOrganizationProjectAppApplicationActivityAuditLogRoute = OrgOrganizationProjectAppApplicationActivityAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationActivityRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute = OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRoute = OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteImport.update({
    id: '/release-pipeline-board',
    path: '/release-pipeline-board',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRoute = OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteImport.update({
    id: '/release-pipeline',
    path: '/release-pipeline',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute = OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteImport.update({
    id: '/environment',
    path: '/environment',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsTagsIndexRoute = OrgOrganizationProjectAppApplicationDevopsTagsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineIndexRoute = OrgOrganizationProjectAppApplicationDevopsReleasePipelineIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardIndexRoute = OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsEnvironmentIndexRoute = OrgOrganizationProjectAppApplicationDevopsEnvironmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsTagsAddRoute = OrgOrganizationProjectAppApplicationDevopsTagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsTagsTagRoute = OrgOrganizationProjectAppApplicationDevopsTagsTagRouteImport.update({
    id: '/$tag',
    path: '/$tag',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsEnvironmentAddRoute = OrgOrganizationProjectAppApplicationDevopsEnvironmentAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectAppApplicationDevopsEnvironmentEnvironmentRoute = OrgOrganizationProjectAppApplicationDevopsEnvironmentEnvironmentRouteImport.update({
    id: '/$environment',
    path: '/$environment',
    getParentRoute: ()=>OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectApplicationsRouteRouteChildren = {
    OrgOrganizationProjectApplicationsIndexRoute: OrgOrganizationProjectApplicationsIndexRoute
};
const OrgOrganizationProjectApplicationsRouteRouteWithChildren = OrgOrganizationProjectApplicationsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationsRouteRouteChildren);
const OrgOrganizationProjectSettingsRouteRouteChildren = {
    OrgOrganizationProjectSettingsCollaborationsTeamsRoute: OrgOrganizationProjectSettingsCollaborationsTeamsRoute,
    OrgOrganizationProjectSettingsGeneralRoute: OrgOrganizationProjectSettingsGeneralRoute
};
const OrgOrganizationProjectSettingsRouteRouteWithChildren = OrgOrganizationProjectSettingsRouteRoute._addFileChildren(OrgOrganizationProjectSettingsRouteRouteChildren);
const OrgOrganizationProjectAppApplicationActivityRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationActivityAuditLogRoute: OrgOrganizationProjectAppApplicationActivityAuditLogRoute,
    OrgOrganizationProjectAppApplicationActivityContributorsRoute: OrgOrganizationProjectAppApplicationActivityContributorsRoute
};
const OrgOrganizationProjectAppApplicationActivityRouteRouteWithChildren = OrgOrganizationProjectAppApplicationActivityRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationActivityRouteRouteChildren);
const OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationDevopsEnvironmentEnvironmentRoute: OrgOrganizationProjectAppApplicationDevopsEnvironmentEnvironmentRoute,
    OrgOrganizationProjectAppApplicationDevopsEnvironmentAddRoute: OrgOrganizationProjectAppApplicationDevopsEnvironmentAddRoute,
    OrgOrganizationProjectAppApplicationDevopsEnvironmentIndexRoute: OrgOrganizationProjectAppApplicationDevopsEnvironmentIndexRoute
};
const OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteWithChildren = OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteChildren);
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationDevopsReleasePipelineIndexRoute: OrgOrganizationProjectAppApplicationDevopsReleasePipelineIndexRoute
};
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteWithChildren = OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteChildren);
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardIndexRoute: OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardIndexRoute
};
const OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteWithChildren = OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteChildren);
const OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationDevopsTagsTagRoute: OrgOrganizationProjectAppApplicationDevopsTagsTagRoute,
    OrgOrganizationProjectAppApplicationDevopsTagsAddRoute: OrgOrganizationProjectAppApplicationDevopsTagsAddRoute,
    OrgOrganizationProjectAppApplicationDevopsTagsIndexRoute: OrgOrganizationProjectAppApplicationDevopsTagsIndexRoute
};
const OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteWithChildren = OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteChildren);
const OrgOrganizationProjectAppApplicationDevopsRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRoute: OrgOrganizationProjectAppApplicationDevopsEnvironmentRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRoute: OrgOrganizationProjectAppApplicationDevopsReleasePipelineRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRoute: OrgOrganizationProjectAppApplicationDevopsReleasePipelineBoardRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationDevopsTagsRouteRoute: OrgOrganizationProjectAppApplicationDevopsTagsRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationDevopsDeploymentIntegrationsRoute: OrgOrganizationProjectAppApplicationDevopsDeploymentIntegrationsRoute,
    OrgOrganizationProjectAppApplicationDevopsRedeploymentRoute: OrgOrganizationProjectAppApplicationDevopsRedeploymentRoute
};
const OrgOrganizationProjectAppApplicationDevopsRouteRouteWithChildren = OrgOrganizationProjectAppApplicationDevopsRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationDevopsRouteRouteChildren);
const OrgOrganizationProjectAppApplicationSettingsRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationSettingsDeploymentIntegrationsRoute: OrgOrganizationProjectAppApplicationSettingsDeploymentIntegrationsRoute,
    OrgOrganizationProjectAppApplicationSettingsGeneralRoute: OrgOrganizationProjectAppApplicationSettingsGeneralRoute,
    OrgOrganizationProjectAppApplicationSettingsIndexRoute: OrgOrganizationProjectAppApplicationSettingsIndexRoute
};
const OrgOrganizationProjectAppApplicationSettingsRouteRouteWithChildren = OrgOrganizationProjectAppApplicationSettingsRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationSettingsRouteRouteChildren);
const OrgOrganizationProjectAppApplicationVersionsRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationVersionsVersionidRoute: OrgOrganizationProjectAppApplicationVersionsVersionidRoute,
    OrgOrganizationProjectAppApplicationVersionsIndexRoute: OrgOrganizationProjectAppApplicationVersionsIndexRoute
};
const OrgOrganizationProjectAppApplicationVersionsRouteRouteWithChildren = OrgOrganizationProjectAppApplicationVersionsRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationVersionsRouteRouteChildren);
const OrgOrganizationProjectAppApplicationRouteRouteChildren = {
    OrgOrganizationProjectAppApplicationActivityRouteRoute: OrgOrganizationProjectAppApplicationActivityRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationDevopsRouteRoute: OrgOrganizationProjectAppApplicationDevopsRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationSettingsRouteRoute: OrgOrganizationProjectAppApplicationSettingsRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationVersionsRouteRoute: OrgOrganizationProjectAppApplicationVersionsRouteRouteWithChildren,
    OrgOrganizationProjectAppApplicationIndexRoute: OrgOrganizationProjectAppApplicationIndexRoute,
    OrgOrganizationProjectAppApplicationUmlIndexRoute: OrgOrganizationProjectAppApplicationUmlIndexRoute
};
const OrgOrganizationProjectAppApplicationRouteRouteWithChildren = OrgOrganizationProjectAppApplicationRouteRoute._addFileChildren(OrgOrganizationProjectAppApplicationRouteRouteChildren);
const OrgOrganizationProjectRouteRouteChildren = {
    OrgOrganizationProjectApplicationsRouteRoute: OrgOrganizationProjectApplicationsRouteRouteWithChildren,
    OrgOrganizationProjectSettingsRouteRoute: OrgOrganizationProjectSettingsRouteRouteWithChildren,
    OrgOrganizationProjectIndexRoute: OrgOrganizationProjectIndexRoute,
    OrgOrganizationProjectAppApplicationRouteRoute: OrgOrganizationProjectAppApplicationRouteRouteWithChildren,
    OrgOrganizationProjectDevopsDeploymentIntegrationsRoute: OrgOrganizationProjectDevopsDeploymentIntegrationsRoute
};
const OrgOrganizationProjectRouteRouteWithChildren = OrgOrganizationProjectRouteRoute._addFileChildren(OrgOrganizationProjectRouteRouteChildren);
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute
};
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteWithChildren = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute._addFileChildren(OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteChildren);
const OrgOrganizationSettingsDeploymentIntegrationsRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteWithChildren,
    OrgOrganizationSettingsDeploymentIntegrationsIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIndexRoute
};
const OrgOrganizationSettingsDeploymentIntegrationsRouteRouteWithChildren = OrgOrganizationSettingsDeploymentIntegrationsRouteRoute._addFileChildren(OrgOrganizationSettingsDeploymentIntegrationsRouteRouteChildren);
const OrgOrganizationSettingsServerTokensRouteRouteChildren = {
    OrgOrganizationSettingsServerTokensTokenRoute: OrgOrganizationSettingsServerTokensTokenRoute,
    OrgOrganizationSettingsServerTokensNewRoute: OrgOrganizationSettingsServerTokensNewRoute,
    OrgOrganizationSettingsServerTokensIndexRoute: OrgOrganizationSettingsServerTokensIndexRoute
};
const OrgOrganizationSettingsServerTokensRouteRouteWithChildren = OrgOrganizationSettingsServerTokensRouteRoute._addFileChildren(OrgOrganizationSettingsServerTokensRouteRouteChildren);
const OrgOrganizationSettingsSubscriptionRouteRouteChildren = {
    OrgOrganizationSettingsSubscriptionManageRoute: OrgOrganizationSettingsSubscriptionManageRoute,
    OrgOrganizationSettingsSubscriptionIndexRoute: OrgOrganizationSettingsSubscriptionIndexRoute
};
const OrgOrganizationSettingsSubscriptionRouteRouteWithChildren = OrgOrganizationSettingsSubscriptionRouteRoute._addFileChildren(OrgOrganizationSettingsSubscriptionRouteRouteChildren);
const OrgOrganizationSettingsTeamsRouteRouteChildren = {
    OrgOrganizationSettingsTeamsTeamRoute: OrgOrganizationSettingsTeamsTeamRoute,
    OrgOrganizationSettingsTeamsIndexRoute: OrgOrganizationSettingsTeamsIndexRoute
};
const OrgOrganizationSettingsTeamsRouteRouteWithChildren = OrgOrganizationSettingsTeamsRouteRoute._addFileChildren(OrgOrganizationSettingsTeamsRouteRouteChildren);
const OrgOrganizationSettingsRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsRouteRoute: OrgOrganizationSettingsDeploymentIntegrationsRouteRouteWithChildren,
    OrgOrganizationSettingsServerTokensRouteRoute: OrgOrganizationSettingsServerTokensRouteRouteWithChildren,
    OrgOrganizationSettingsSubscriptionRouteRoute: OrgOrganizationSettingsSubscriptionRouteRouteWithChildren,
    OrgOrganizationSettingsTeamsRouteRoute: OrgOrganizationSettingsTeamsRouteRouteWithChildren,
    OrgOrganizationSettingsAuditLogRoute: OrgOrganizationSettingsAuditLogRoute,
    OrgOrganizationSettingsMembershipRoute: OrgOrganizationSettingsMembershipRoute,
    OrgOrganizationSettingsPeopleRoute: OrgOrganizationSettingsPeopleRoute,
    OrgOrganizationSettingsIndexRoute: OrgOrganizationSettingsIndexRoute
};
const OrgOrganizationSettingsRouteRouteWithChildren = OrgOrganizationSettingsRouteRoute._addFileChildren(OrgOrganizationSettingsRouteRouteChildren);
const OrgOrganizationRouteRouteChildren = {
    OrgOrganizationProjectRouteRoute: OrgOrganizationProjectRouteRouteWithChildren,
    OrgOrganizationProjectsRouteRoute: OrgOrganizationProjectsRouteRoute,
    OrgOrganizationSettingsRouteRoute: OrgOrganizationSettingsRouteRouteWithChildren,
    OrgOrganizationManagedApplicationsRoute: OrgOrganizationManagedApplicationsRoute,
    OrgOrganizationIndexRoute: OrgOrganizationIndexRoute
};
const OrgOrganizationRouteRouteWithChildren = OrgOrganizationRouteRoute._addFileChildren(OrgOrganizationRouteRouteChildren);
const OrgRouteRouteChildren = {
    OrgOrganizationRouteRoute: OrgOrganizationRouteRouteWithChildren
};
const OrgRouteRouteWithChildren = OrgRouteRoute._addFileChildren(OrgRouteRouteChildren);
const ProfileRouteChildren = {
    ProfileIndexRoute: ProfileIndexRoute,
    ProfileSettingsEmailSettingsRoute: ProfileSettingsEmailSettingsRoute,
    ProfileUsernameIndexRoute: ProfileUsernameIndexRoute,
    ProfileSettingsIndexRoute: ProfileSettingsIndexRoute,
    ProfileSettingsUserTokensUsertokenRoute: ProfileSettingsUserTokensUsertokenRoute,
    ProfileSettingsUserTokensGenerateRoute: ProfileSettingsUserTokensGenerateRoute,
    ProfileSettingsUserTokensIndexRoute: ProfileSettingsUserTokensIndexRoute
};
const ProfileRouteWithChildren = ProfileRoute._addFileChildren(ProfileRouteChildren);
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    OrgRouteRoute: OrgRouteRouteWithChildren,
    R403Route: R403Route,
    LoginRoute: LoginRoute,
    LogoutRoute: LogoutRoute,
    ProfileRoute: ProfileRouteWithChildren,
    AuthCallbackRoute: AuthCallbackRoute,
    AuthVerifyEmailRoute: AuthVerifyEmailRoute
};
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes();
